export const appThemeEnum = {
    Dark: "dark",
    Light: "light"
}